import React, { Component } from 'react';
import './Card.css';

import suitClubs from './img/suit-clubs.png';
import suitDiamonds from './img/suit-diamonds.png';
import suitHearts from './img/suit-hearts.png';
import suitSpades from './img/suit-spades.png';
import suitFaceDown from './img/back.jpg';

class Card extends Component {
  render() {
    let suit;
    let alt;
    switch (this.props.suit) {
      case 'c':
        suit = suitClubs; alt = 'clubs'; break;
      case 'd':
        suit = suitDiamonds; alt = 'diamonds'; break;
      case 'h':
        suit = suitHearts; alt = 'hearts'; break;
      case 's':
        suit = suitSpades; alt = 'spades'; break;
      case 'X':
        suit = suitFaceDown; alt = 'face down'; break;
      default:
    }
    const w = this.props.winner ? 'winner' : '';
    return (
      <div className={`card ${w} r-${this.props.rank} s-${this.props.suit}`}>
        <div className="rank">{this.props.rank}</div>
        <img className="suit" src={suit} alt={alt}/>
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/Card.js